/* Pattern for ad hoc query against relay store */
import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
      
const query = graphql`
query CustomerStatementLinesFetchQuery($cAccountId: UUID, $startDate: Datetime, $endDate: Datetime, $first: Int, $offset: Int) {
  getcustomerstatementlines2(caccountid: $cAccountId, startts: $startDate, endts: $endDate, first: $first, offset: $offset) {
    totalCount
    nodes {
      beginningBalance
      paymentIn
      receivedIn
      chargeOut
      payoutOut
      endingBalance
      transactionId
      transactionTime
      transactionType
      accountId
      accountName
      psType
      psCcBrand
      psCcLast4
      psAchAccountNum
      psInAmt
      psOutAmt
      psCFee
      psRFee
      paymentStatus
      paymentStatusReason
      bcId
      bcLast4
      customerAppId
      appId
      appName
      appLogo
      bindCardCharge
      markup
      appbindFee
      passThroughFee
      balance
    }
  }
}
`;

function fetch(cAccountId, startDate, endDate, first, offset) {
  const variables = {
    cAccountId: cAccountId, 
    startDate: startDate,
    endDate: endDate,
    first: first,
    offset: offset
  }
    
  return fetchQuery(
      abEnvironment.getEnvironment(),
      query,
      variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */ 
export default { fetch };